<ra-modal
    [title]="'document.edit.history.title' | translate"
    [animation]="'slide-right'"
    [size]="'medium'"
    (close)="close.emit()">

    <div class="history-root">
        <!-- Timeline (rola dentro do drawer) -->
        <div class="timeline-area">
            @if (history.loading() && history.events().length === 0) {
                <ra-loading [message]="'document.edit.history.loading' | translate" [marginTop]="40" />
            } @else if (history.events().length === 0) {
                <ra-empty
                    [width]="'100%'"
                    [marginTop]="48"
                    [title]="'document.edit.history.emptyTitle' | translate"
                    [message]="'document.edit.history.emptyMessage' | translate" />
            } @else {
                <div class="timeline">
                    @for (event of history.events(); track event._id) {
                        <document-history-item [event]="event" (openDiff)="diffEvent.set($event)" />
                    }
                </div>

                @if (history.hasMore()) {
                    <button
                        class="load-more"
                        type="button"
                        [disabled]="history.loading()"
                        (click)="history.loadMore()">
                        {{
                            (history.loading()
                                ? 'document.edit.history.loading'
                                : 'document.edit.history.loadMore'
                            ) | translate
                        }}
                    </button>
                }
            }
        </div>

        <!-- Rodapé fixo: registro imutável -->
        <div class="foot">{{ 'document.edit.history.footer' | translate }}</div>
    </div>
</ra-modal>

@if (diffEvent(); as ev) {
    <audit-diff-modal
        [title]="diffTitle(ev)"
        [before]="metaStr(ev, 'before')"
        [after]="metaStr(ev, 'after')"
        (close)="diffEvent.set(null)" />
}
